module.exports = __webpack_public_path__ + "static/img/s79.e603bad0.png";